import React from 'react';
import LitImage from '../../components/images/LitImage';

const ComparisonCard = ({ src, title, subtitle, lineType, speeds, reliability, isGold }) => {
  return (
    <>
      <div className="container">
        <div className='text-center comparison-card-img'>
          <LitImage
            image={src}
            alt="Icon"
            style={{ width: 'auto', height: '100px', margin: '0 auto'}}
            loading="lazy"
          />
        </div>
        <div className={`comparison-card ${isGold ? 'card-gold' : ''}`} >
          <h5 className='text-center'>
            <div>
            {title}
            <span className='comparison-card-subtitle'>{subtitle}</span>
            </div>
            
          </h5>
          <div className='row'>
            <div className='col-md-12 row'>
              <span className='location-col-6 comparison-card-flex-end'><strong>Line type:</strong></span>
              <span className='location-col-6'>{lineType}</span>
              <span className='location-col-6 comparison-card-flex-end'><strong>Speeds:</strong></span>
              <span className='location-col-6'>{speeds}</span>
              <span className='location-col-6 comparison-card-flex-end'><strong>Reliability:</strong></span>
              <span className='location-col-6'>{reliability}</span>
            </div>
          </div>
        </div>    
      </div>
    </>
  )
}

export default ComparisonCard